
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"15","viewBox":"0 0 20 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.625 4.99999C18.625 2.79086 16.8341 1 14.625 1H6.83269C6.37238 1 5.97783 1.20585 5.7148 1.61756L1.375 7.17558L5.7148 12.7336C5.97783 13.0767 6.37238 13.3512 6.83269 13.3512H14.625C16.8341 13.3512 18.625 11.5603 18.625 9.35115C18.625 7.90077 18.625 6.45038 18.625 4.99999Z","stroke":"#61656A","stroke-width":"1.5","stroke-linecap":"square"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.9326 10.4155C13.2192 10.7145 13.694 10.7246 13.9931 10.438C14.2921 10.1514 14.3022 9.67667 14.0156 9.37761L12.2403 7.52512L14.0156 5.67265C14.3022 5.37359 14.2921 4.89882 13.993 4.61223C13.694 4.32563 13.2192 4.33573 12.9326 4.63479L11.2015 6.44116L9.47041 4.63479C9.18381 4.33573 8.70904 4.32563 8.40999 4.61223C8.11093 4.89882 8.10083 5.37359 8.38742 5.67265L10.1627 7.52512L8.3874 9.37761C8.10081 9.67667 8.11091 10.1514 8.40997 10.438C8.70902 10.7246 9.18379 10.7145 9.47039 10.4155L11.2015 8.60908L12.9326 10.4155Z","fill":"#61656A"}})])
          )
        }
      }
    